<script>
import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
import { onMount } from "svelte";
import * as Fx from '../../globals/Fx.js'
import { createEventDispatcher } from "svelte";
import GLOBALS from "../../globals/GLOBALS";


String.prototype.lines = function() { return this.split(/\r*\n/); }
String.prototype.lineCount = function() { return this.lines().length; }

const dispatch = createEventDispatcher();

export let periodo

let DATOSTABLA
let link
let rowSelected = null
let idSelected = null
let showSave = false
let inputConsumo = 0
let susxfuera = false
let showsaveAddSuscriptor = false
let rows

onMount(() =>{
    _LIQ_QUERY("LISTACONSUMOS", {periodo})
})

const _LIQ_QUERY = async (QUERY, data) => {
    // const data = {};
    const URL = GLOBALS.URL;
    const bearer = "Bearer " + $TOKEN_SESSION;
    await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: bearer,
            "Content-type": "application/json;charset=UTF-8",
        },
    })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then(async (json) => {
            if (json.status === 403) TOKEN_SESSION.set(null)
            if (json.result === "success") {
                switch(QUERY){
                    case "LISTACONSUMOS":
                        susxfuera = false
                        DATOSTABLA = json.rows
                        TOAST_MESSAGE.set(json)
                    break;
                    case "LISTASUSXFUERA":
                        susxfuera = true
                        DATOSTABLA = json.rows
                        TOAST_MESSAGE.set(json)
                    break;
                    case "INSERTINTOLIQDETALLEXFUERA":
                        TOAST_MESSAGE.set(json)
                        showsaveAddSuscriptor = false
                        await _LIQ_QUERY("LISTASUSXFUERA", {periodo})
                    break;
                    case "REMOVESUSFROMLIQDET":
                        idSelected = null
                        await _LIQ_QUERY("LISTACONSUMOS", {periodo})
                    break;
                }
            }else{
                switch(QUERY){
                    case "LISTASUSXFUERA":
                        susxfuera = false
                        await _LIQ_QUERY("LISTACONSUMOS", {periodo})
                    break;
                }
                TOAST_MESSAGE.set(json)
            }

        }) //print data to console
        .catch((err) => console.log("Request Failed", err)); // Catch errors
};


const _close = () => {
    dispatch("close")
}

const settings = {
        sortable: true,
        rowsPerPage: 1000,
        columnFilter: true,
        labels: {
            search: "Buscar...", // search input placeholer
            filter: "Filtro", // filter inputs placeholder
            noRows: "Registro no encontrado",
            info: "Mostrando {start} a {end} de {rows} registros",
            previous: "Anterior",
            next: "Sguiente",
        },
        blocks: {
            searchInput: false,
            paginationButtons: false,
            paginationRowCount: false,
        }
    };

    const _exportExcel = () => {
        let HTML = `<tabla>
            <thead>
                <th data-key="num">#</th>
                <th data-key="liq_periodo">Periodo</th>
                <th data-key="liq_id_contrato">Contrato Id</th>
                <th data-key="sus_nombre">Nombre</th>
                <th data-key="sus_nit">NIT</th>
                <th data-key="estrato">Estrato</th>
                <th data-key="tarifa">Tarifa Id</th>
                <th class="text-end" data-key="liq_csmo_energia">Csmo Energía</th>
            </thead>
            `
        DATOSTABLA.forEach(element => {
            HTML += `<tr>`
            Object.keys(element).forEach((key) => {
                // HTML += `<td>${element[key]}</td>`
                if ((`liq_csmo_energia`).indexOf(key) > -1){
                    HTML += `<td>${Fx.formatter.format(element[key]).cop()}</td>`
                }else{
                    HTML += `<td>${element[key]}</td>`
                }
            })
            HTML += `</td>`
        })
        HTML += `</table>`

        const data = Fx.fnExcelReport(HTML, "Listado de Consumos Cargados en el Periodo")
        link.setAttribute("href", data.data_type + ', ' + encodeURIComponent(Fx.myUTF8(data.tab_text)));
        link.setAttribute("download", "Lista_consumos.xls")
        
    }

    const _toggleSelect = async (id, row) => {
        if (showSave && idSelected !== id) {
            const opc = confirm("Atención! No has guardado los cambios. ¿Deseas descartarlos?")
            if (opc)
                await _LIQ_QUERY("LISTACONSUMOS", {periodo})
            else 
                return
            showSave = false
            idSelected = null;
        }else{
            idSelected = id;
            rowSelected = row
            showsaveAddSuscriptor = susxfuera ? true : false
        }
    };

    const _changeInput = () => {
        showSave = true
    }

    const _saveConsumo = async  () => {
        showSave = false
        let data = []
        data.push({liq_id_contrato:rowSelected.liq_id_contrato,liq_csmo_energia:inputConsumo.value})
        await _LIQ_QUERY("SAVECONSUMOS",{periodo,data})
        _LIQ_QUERY("LISTACONSUMOS", {periodo})
    }

    const onKeyPress = e => {
        if (e.charCode === 13 && showSave) {
            _saveConsumo()
        }
    };

    const _listarSuscriptxfuera = async () => {
        await _LIQ_QUERY("LISTASUSXFUERA", {periodo})
    }

    const _showListaConsumos = async () => {
        await _LIQ_QUERY("LISTACONSUMOS", {periodo})
    }

    const _addSuscriptor = async () => {
        const sus_id_contrato = idSelected.split("row-")[1]
        await _LIQ_QUERY("INSERTINTOLIQDETALLEXFUERA", {periodo, sus_id_contrato})
        
    }

    const _removeSuscriptor = async () => {
        const res = confirm("¿Realmente desea remover el suscriptor del periodo? Recuerde que esta acción equivale a eliminar la liquidación del periodo actual y no puede ser reversada.")
        if (res) {
            const sus_id_contrato = idSelected.split("row-")[1]
            await _LIQ_QUERY("REMOVESUSFROMLIQDET", {periodo, sus_id_contrato})
        }
    }


</script>

<div class="datatable-container">
    <div class="d-flex direction-row justify-content-between">
        <h4>{susxfuera ? `Suscriptores que no se encuentran en el periodo ${periodo}` : "Revisión de Consumos Cargados"}</h4>
        <!-- <div class="btn btn-danger align-self-end"  on:click={() => _close()}>Cerrar</div> -->
       
        <div class="d-flex direction-row justify-content-between">
            {#if !susxfuera}
                {#if idSelected}
                    <div title={"Remover Suscriptor del Periodo"} class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={() => _removeSuscriptor()}>
                        <ion-icon name="close-outline"></ion-icon>
                    </div>
                {/if}
                <div title={"Mostrar Suscriptores por fuera del periodo"} class="circular d-flex justify-content-center align-items-center" style="background-color:#3498db" on:click={() => _listarSuscriptxfuera()}>
                    <ion-icon name="person-add-outline"></ion-icon>
                </div>
            {:else}
                <div title={"Volver"} class="circular d-flex justify-content-center align-items-center" style="background-color:#8e44ad" on:click={() => _showListaConsumos()}>
                    <ion-icon name="return-up-back-outline"></ion-icon>
                </div>
                {#if showsaveAddSuscriptor}
                    <div title={"Agregar Suscriptor al periodo"} class="circular d-flex justify-content-center align-items-center" style="background-color:#e74c3c" on:click={() => _addSuscriptor()}>
                        <ion-icon name="checkmark-outline"></ion-icon>
                    </div>
                {/if}
            {/if}
            
            {#if showSave}
                <div class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={() => _saveConsumo()} title={"Confirmar Consumo" }>
                    <ion-icon name="save-sharp"></ion-icon>
                </div>
            {/if}
            <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()} title={"Exportar a Excel"}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
                  </svg>
            </a>
            <div title={"Cerrar"} class="circular d-flex justify-content-center align-items-center" on:click={() => _close()}>
                <ion-icon name="close-outline"></ion-icon>
            </div>
        </div>
    </div>
    {#if DATOSTABLA && !susxfuera}
         <Datatable {settings} data={DATOSTABLA} bind:dataRows={rows} id={"consumos-table"}>
            <thead>
                <tr>
                    <th data-key="num">#</th>
                    <th data-key="liq_periodo">Periodo</th>
                    <th data-key="liq_id_contrato">Contrato Id</th>
                    <th data-key="sus_nombre">Nombre</th>
                    <th data-key="sus_nit">NIT</th>
                    <th data-key="estrato">Estrato</th>
                    <th data-key="tarifa">Tarifa Id</th>
                    <th class="text-end" data-key="liq_csmo_energia">Csmo Energía</th>
                </tr>
            </thead>
            <tbody>
                {#if rows}
                    {#each $rows as row, idx}
                        <tr
                                class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}"
                                class:active={`row-${row.liq_id_contrato}` ===  idSelected}
                                on:click={() => _toggleSelect(`row-${row.liq_id_contrato}`, row)}

                        >
                                <td class="text-center" col="2">{row.num}</td>
                                <td class="text-center">{row.liq_periodo}</td>
                                <td class="text-center">{row.liq_id_contrato}</td>
                                <td>{row.sus_nombre}</td>
                                <td>{row.sus_nit}</td>
                                <td class="text-center">{row.estrato}</td>
                                <td class="text-center">{row.tarifa}</td>
                                <td class="text-end d-flex flex-row" style="color:tomato;background-color:#ff634722">
                                    {#if `row-${row.liq_id_contrato}` !==  idSelected}
                                        <div class="text-end" style="width:100%">{Fx.formatter.format(row.liq_csmo_energia).cop()}</div>
                                    {:else}
                                        <input 
                                            class="inputCsmo" 
                                            type="text" 
                                            bind:this={inputConsumo}
                                            value={row.liq_csmo_energia} 
                                            on:input={() => _changeInput()}
                                            on:keypress={onKeyPress}
                                        />
                                    {/if}
                                </td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </Datatable>
    {/if}
    {#if DATOSTABLA && susxfuera}
         <Datatable {settings} data={DATOSTABLA} bind:dataRows={rows} id={"consumos-table-x"}>
            <thead>
                <th data-key="num">#</th>
                <th data-key="sus_id_contrato">Contrato Id</th>
                <th data-key="sus_nombre">Nombre</th>
                <th data-key="sus_nit">NIT</th>
                <th data-key="sus_direccion">Dirección</th>
            </thead>
            <tbody>
                {#if rows}                    
                    {#each $rows as row, idx}
                        <tr
                                class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}"
                                class:active={`row-${row.sus_id_contrato}` ===  idSelected}
                                on:click={() => _toggleSelect(`row-${row.sus_id_contrato}`, row)}

                        >
                                <td class="text-center" col="2">{row.num}</td>
                                <td class="text-center">{row.sus_id_contrato}</td>
                                <td>{row.sus_nombre}</td>
                                <td>{row.sus_nit}</td>
                                <td>{row.sus_direccion}</td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </Datatable>
    {/if}    
</div>
<footer>
    {#if DATOSTABLA && !susxfuera}
        <PaginationButtons id={"consumos-table"}/>
        <PaginationRowCount id={"consumos-table"}/>
    {/if}
    {#if DATOSTABLA && susxfuera}
        <PaginationButtons id={"consumos-table-x"}/>
        <PaginationRowCount id={"consumos-table-x"}/>
    {/if}
</footer>


<style>

    footer {
        position: fixed;
        display: flex;
        background-color: #fff;
        bottom:0;
        width: 100%;
        padding: 10px;
    }

    th {
        min-width: 10em;
        text-align: left;
    }

    td {
        text-align: left;
        white-space: nowrap;
        padding: 10px 10px;
    }

    tr {
        cursor: pointer;
        color: #3f51b5b5;
        font-size: 0.8em;
        transition: background-color 500ms;
    }

    tr:hover {
        background-color:#14518d33;
        color: #2c3e50;
    }

    tr.active {
        background-color: #2c3e50 !important;
        color: #fff !important;
    }

    .datatable-container {
        height: 76vh;
        max-height: 100vh;
        padding-top: 12px;
        margin-bottom: 40px;
        /* margin: 20px 0; */
    }

    .bg-par {
        background-color: #fafcff;
    }

    .bg-impar {
        background-color: #f2f6ff;
    }

    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color : #fff;
        cursor: pointer;
        transition: all 250ms;
        margin-right: 10px;
    }

    .circular:hover {
        transform: scale(1.2);
    }

    .inputCsmo {
        border: 0;
        text-align: right;
        background-color: transparent;
        min-width: 1em;
        color:#fff;
    }

    input:focus {
        color: #FFF;
    }

</style>